import {Option} from "../AbstractDropDown";
import {ProposalStatusBadge} from "../../proposal/ProposalStatusBadge";
import {AbstractDropDownMultiple} from "../AbstractDropDownMultiple";
import React, {ReactNode} from "react";
import {useAuthStore} from "../../../store/auth.store";

const style = {display: 'inline-block'}

interface Props {
    submitHappen?: boolean,
    single?: boolean,
    allowEmpty?: boolean,
    onChange: (v: string[]) => void,
    value: string[],
    label?: string
    disabled?: boolean
    includeHints?: boolean
    renderValueWrapper?: (selectedOptions:ReactNode[]) => React.ReactNode
    className?: string
}

export function getProposalOptions(canManageProposals:boolean, includeHints?:boolean) {
    const options: Option[] = [
        {value: 'AGENT', label: <ProposalStatusBadge includeHints={includeHints} style={style} status={'AGENT'}/>},
        {value: 'OWNER', label: <ProposalStatusBadge includeHints={includeHints} style={style} status={'OWNER'}/>},
        {value: 'NO_RESPONSE', label: <ProposalStatusBadge includeHints={includeHints} style={style} status={'NO_RESPONSE'}/>},
        {value: 'AUTO_COMPLETE', label: <ProposalStatusBadge includeHints={includeHints} style={style} status={'AUTO_COMPLETE'}/>},
        {value: 'MANUAL', label: <ProposalStatusBadge includeHints={includeHints} style={style} status={'MANUAL'}/>},
        {value: 'REJECTED', label: <ProposalStatusBadge includeHints={includeHints} style={style} status={'REJECTED'}/>},
        {value: 'SOLD', label: <ProposalStatusBadge includeHints={includeHints} style={style} status={'SOLD'}/>},
    ];
    if (canManageProposals) {
        options.push({value: 'AUTO_INITIAL', label: <ProposalStatusBadge includeHints={includeHints} style={style} status={'AUTO_INITIAL'}/>});
        options.push({
            value: 'AUTO_INCOMPLETE',
            label: <ProposalStatusBadge includeHints={includeHints} style={style} status={'AUTO_INCOMPLETE'}/>
        });
        options.push({value: 'AUTO_ERROR', label: <ProposalStatusBadge includeHints={includeHints} style={style} status={'AUTO_ERROR'}/>});
        options.push({value: 'DELETED', label: <ProposalStatusBadge includeHints={includeHints} style={style} status={'DELETED'}/>});
    }
    return options;
}

export function ProposalStatusDropdown({renderValueWrapper, includeHints, className, disabled, single, allowEmpty, value, onChange, label, submitHappen}: Props) {
    const {can} = useAuthStore();

    const options = getProposalOptions(can('manage_proposals'), includeHints)


    return <AbstractDropDownMultiple
        sx={{
            '& .MuiOutlinedInput-input': {
                padding: '13px 32px 13px 12px !important'
            }
        }}
        renderValueWrapper={renderValueWrapper}
        className={className}
        disabled={disabled}
        submitHappen={submitHappen}
        options={options}
        value={allowEmpty ? value : (value && value.length > 0 ? value : ["AUTO_ERROR"])}
        single={single}
        label={label}
        onChange={onChange}/>
}